module.exports = "<list-view\n  active-params=\"$ctrl.activeParams\"\n  filter-event=\"$ctrl.filterEvent\"\n  page=\"$ctrl.page\"\n  total=\"$ctrl.total\"\n  limit=\"$ctrl.limit\"\n  item-state=\"corporate\"\n  paginate-event=\"$ctrl.paginateEvent\"\n  sort-event=\"$ctrl.sortEvent\"\n  add-item-event=\"$ctrl.addItemEvent\"\n  title=\"Corporates\"\n  resource=\"Corporate\"\n  transformer=\"CorporatesTransforms\"\n  no-items-text=\"No Corporates Yet!\"\n></list-view>\n\n<main-footer></main-footer>\n<main-sidenav sections=\"$ctrl.sections\">\n  <main-sidenav></main-sidenav>\n</main-sidenav>\n";


//////////////////
// WEBPACK FOOTER
// ./src/pages/corporates/corporates.html
// module id = 1265
// module chunks = 0